import {db} from '../../firebase/index';

export const updateUsersList = () => {
    return async (dispatch) => {
        const snapshots = await db.collection('users').get();
        let list = {};
        snapshots.docs.map((value) => {
            const userId = value.id;
            const nickName = value.data().nick_name;
            return list[userId] = nickName
        });
        dispatch(updateUsersState(list))
    }
};

// Define Action Creators
export const UPDATE_USERS_STATE = "UPDATE_USERS_STATE";
export const updateUsersState = (userNameList) => {
    return {
        type: "UPDATE_USERS_STATE",
        payload: userNameList
    }
};